import axios from "axios";
import * as _ from "lodash";
import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorker from "./serviceWorkerRegistration";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { i18nUserContext } from "config/translations/I18n";
import { store, persistor } from "store/configure-store";
import { BrowserRouter } from "react-router-dom";

import { ThemeProvider } from "styled-components";
import defaultTheme from "./components/CareConnectMobile-Theme";
import App from "./App";
import { PersistGate } from "redux-persist/integration/react";
import { visitConfig } from "config";
import { setupHttp } from "api/base-config";
import moment from "moment";
import { setupMatomo } from "api/matomo-config";
import { MatomoProvider } from "@datapunt/matomo-tracker-react";

axios
  .create()
  .get(`/config.json?timestamp=${moment().toDate().getTime()}`)
  .then((response) => {
    _.merge(visitConfig, {
      backendUrl: response.data.backendUrl,
      corilusPassportUrl: response.data.corilusPassportUrl,
      matomoBaseUrl: response.data.matomoBaseUrl,
      matomoSiteId: response.data.matomoSiteId,
    });

    setupHttp(store, visitConfig);
    const matomoInstance = setupMatomo(visitConfig);

    ReactDOM.render(
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <I18nextProvider i18n={i18nUserContext}>
            <BrowserRouter>
              <ThemeProvider theme={defaultTheme}>
                <React.Fragment>
                  <MatomoProvider value={matomoInstance}>
                    <App visitConfig={visitConfig} />
                  </MatomoProvider>
                </React.Fragment>
              </ThemeProvider>
            </BrowserRouter>
          </I18nextProvider>
        </PersistGate>
      </Provider>,
      document.getElementById("App")
    );
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener("statechange", (event) => {
        // @ts-ignore
        if (event.target.state === "activated") {
          window.location.reload();
        }
      });
      waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
    }
  },
});
